import { useEffect } from "react";
import cn from "clsx";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setConfirmationPopup } from "utils/redux/reducers/confirmationPopupReducer";

const ConfirmationPopUp = () => {
  const dispatch = useDispatch(); // Get the dispatch function from the useDispatch hook
  const reduxConfirmationPopupState = useSelector(
    (state: any) => state.confirmationPopup
  );
  const confirmationPopup = reduxConfirmationPopupState?.confirmationPopup;

  useEffect(() => {
    if (confirmationPopup.isOpen) {
      setTimeout(() => {
        dispatch(
          setConfirmationPopup({
            isOpen: false,
            result: {
              type: "Success",
              message: "Your changes have been saved successfully.",
            },
          })
        );
      }, 8000);
    }
  }, [confirmationPopup]);

  const handleCancel = () => {
    dispatch(
      setConfirmationPopup({
        isOpen: false,
        result: {
          type: "",
          message: "",
        },
      })
    );
  };

  return (
    <div
      className={cn(
        "fixed bottom-[20px] left-[20px] rounded-[4px] w-fit  !z-[9999] p-[15px] min-w-[350px] toast",
        confirmationPopup?.result?.type === "Success"
          ? "bg-[#EDF7ED]"
          : "bg-[#FFF4E5]",
        confirmationPopup?.isOpen ? " h-fit" : "invisible h-[0px]",
        confirmationPopup?.addStyle
      )}
      id="popup-message">
      <button
        className="
                       p-[2px]  border-transparent border-[1px] 
                      hover:shadow-sm hover:border-[#ECEDEF] hover:border-[1px] 
                      focus:shadow-sm focus:border-[#ECEDEF] focus:border-[1px]
                      absolute top-[10px] right-[10px] rounded-[4px]
                    "
        onClick={handleCancel}>
        <img
          src="/assets/icons/Close.svg"
          alt="Close Icon"
          className="w-[18px] h-[18px]"
        />
      </button>
      <div className="flex flex-row gap-[10px] items-start">
        <img
          src="/assets/icons/confirmation-icon.svg"
          alt="Success"
          className={`${
            confirmationPopup?.result?.type === "Success"
              ? "relative"
              : "hidden"
          }`}
        />
        <img
          src="/assets/icons/warning-icon.svg"
          alt="warning"
          className={`${
            confirmationPopup?.result?.type !== "Success"
              ? "relative"
              : "hidden"
          }`}
        />
        <div>
          <div className="text-start mt-[-2px] text-[16px] font-[500]">
            {confirmationPopup?.result?.type}
          </div>
          <div className="mt-[8px] text-[16px]">
            {confirmationPopup?.result?.message}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopUp;
